module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-toolbar'), _vm._v(" "), _c('main', {
    attrs: {
      "id": "view"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('bottomNav', {
    staticClass: "bottomNav"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 763
// module chunks = 8